<template>
  <div class="orderareaboby">
    <div class="orderareaboby_top">
      <el-select v-if="$store.state.Login.Jurisdiction == 0" size="medium" v-model="Factory"
        style="width: 150px; padding: 0px 0px 0px 10px;" clearable :placeholder="$t('system.选择厂区')">
        <el-option v-for="item in $PublicJs.factory" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-input size="medium" clearable v-model="Text" style="width: 270px; padding: 0px 10px 0px 10px;"
        :placeholder="$t('All.品名') + '/' + $t('All.料号') + '/' + $t('All.厂商')"></el-input>
      <el-button type="primary" icon="el-icon-search" size="small" @click="Getwjdiqcdata()">{{ $t('All.搜索')
      }}</el-button>
      <el-button type="warning" icon="el-icon-search" size="small" @click="Geterpiqcdata()">{{ $t('All.手动获取')
      }}</el-button>
    </div>
    <div class="orderareaboby_center">
      <el-table :data="tableData" style="width: 100%" height="100%">
        <el-table-column align="center" type="index" width="60">
        </el-table-column>
        <el-table-column align="center" prop="Rfdoco" :label="$t('All.订单号')" width="120">
        </el-table-column>
        <el-table-column align="center" prop="Rfupmj" :label="$t('All.收料日期')" width="160">
        </el-table-column>
        <el-table-column align="center" prop="Rflitm" :label="$t('All.料号')" width="120">
        </el-table-column>
        <el-table-column align="center" prop="Rfdsc1" :label="$t('All.品名')">
        </el-table-column>
        <el-table-column align="center" prop="Rfdsc2" :label="$t('All.规格')">
        </el-table-column>
        <el-table-column align="center" prop="Rfuorg" :label="$t('All.订单数量')" width="120">
        </el-table-column>
        <el-table-column align="center" prop="Rfqtym" :label="$t('All.收料数量')" width="120">
        </el-table-column>
        <el-table-column align="center" prop="Rfalph" :label="$t('All.供应商')">
        </el-table-column>
        <el-table-column align="center" :label="$t('All.操作')" width="280" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="AdminDataSelect(scope.row)">{{ $t('All.接单') }}</el-button>
            <el-button size="mini" type="warning" @click="mianzuodanhao(scope.row)">{{ $t('All.免做单') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="orderareaboby_boot">
      <el-pagination style="text-align: center;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageindex" :page-sizes="[10, 15, 30, 60, 100]" :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page>
      </el-pagination>
    </div>
    <el-dialog
  :title="$t('All.免做单')"
  :visible.sync="dialogVisible"
  width="30%"
  append-to-body
  :before-close="handleClose">
  <el-input v-model="Numbers" autocomplete="off" placeholder="请输入免做单的单号"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="Updwjdiqcdata()">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  data () {
    return {
      tableData: [],
      total: 0,
      page_size: 15,
      pageindex: 1,
      Text: '',
      Factory: '',
      Department: '',
      Numbers: '',
      Id: 0,
      dialogVisible: false
    }
  },
  props: ['RemoveTab', 'Addtab'],
  created () {
    this.Getwjdiqcdata()
  },
  mounted () {

  },
  methods: {
    ...mapMutations(['UserData', 'TabComponentFun', 'OQCExaminefun']),
    mianzuodanhao (row) {
      this.dialogVisible = true
      this.Id = row.Id
    },
    async Getwjdiqcdata () {
      const intfs = {
        Pageindex: this.pageindex,
        PageSize: this.page_size,
        UserData: this.$store.state.Login,
        Text: this.Text,
        Factory: this.Factory
      }
      const { data: res } = await this.$http.post('/api/NewIQC/Getwjdiqcdata', intfs)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.total = res.response.TotalCount
      this.tableData = res.response.Data
    },
    handleCurrentChange (val) {
      this.pageindex = val
      this.Getwjdiqcdata()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.Getwjdiqcdata()
    },
    async AdminDataSelect (row) {
      const postdata = {
        Item: row.Rflitm,
        Order: row.Rfdoco,
        UserData: this.$store.state.Login,
        Type: 0
      }
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const { data: res } = await this.$http.post('/api/Newiqc/NewIQCSelectausererp', postdata)
        if (res.status !== 200) {
          loadingInstance.close()
          this.$message.error(res.msg)
          return
        }
        loadingInstance.close()
        this.UserData(res.response)
        this.Getwjdiqcdata()
        this.Addtab(this.$t('All.新IQC检验单') + '-' + res.response.Numbers, 'NewIQCExamine')
      } catch (error) {
        loadingInstance.close()
        this.$message.error(error)
      }
    },
    async Updwjdiqcdata () {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const { data: res } = await this.$http.get(`/api/Newiqc/Updwjdiqcdata?Id=${this.Id}&Numbers=${this.Numbers}`)
        if (res.status !== 200) {
          loadingInstance.close()
          this.$message.error(res.msg)
          return
        }
        loadingInstance.close()
        this.$message.success('Ok')
        this.dialogVisible = false
        this.Getwjdiqcdata()
      } catch (error) {
        loadingInstance.close()
        this.$message.error(error)
      }
    },
    async Geterpiqcdata () {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const { data: res } = await this.$http.get('/api/Newiqc/Geterpiqcdata')
        if (res.status !== 200) {
          loadingInstance.close()
          this.$message.error(res.msg)
          return
        }
        loadingInstance.close()
        this.$message.success('Ok')
        this.dialogVisible = false
        this.Getwjdiqcdata()
      } catch (error) {
        loadingInstance.close()
        this.$message.error(error)
      }
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.dialogVisible = false
          this.Numbers = ''
          this.Id = 0
          done()
        })
        .catch(_ => {})
    }
  }
}
</script>
<style lang="less" scoped>
/** talbe表头置顶**/
/deep/ .el-table {
  overflow: visible;
}

/deep/ .el-table__header-wrapper {
  position: sticky;
  top: 0px;
  z-index: 10;
}

.orderareaboby {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.orderareaboby_center {
  flex: 1;
  overflow: auto;
  width: 100%;
  height: calc(100% - 36px);
}
</style>
